import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Settings } from '../../core';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { LOAD_ALL_RESULTS_QUERY_PARAMETER } from './standart-test-result-query-parameters';

@Component({
    selector: 'large-data-warning',
    template: require('./large-data-warning.component.html'),
    styles: [require('./large-data-warning.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LargeDataWarningComponent {

    @Input()
    public showWarning: boolean;

    public maxNumOfSubjects: number;

    constructor(
        settings: Settings,
        private route: ActivatedRoute,
        private router: Router) {
        this.maxNumOfSubjects = settings.extremelyLargeSiteThreshhold;
    }
    
    public toggleLoadAll() {
        const queryParams: Params = {};
        queryParams[LOAD_ALL_RESULTS_QUERY_PARAMETER] = true;

        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: queryParams,
            queryParamsHandling: 'merge'
          });
    }
}